module.exports = __webpack_public_path__ + "static/media/playfair-display-latin-400-normal.a95e3913.woff2";